'use strict';

import Common from '../../Utils/Common';

/**
 * @classname ChangeNewsCategory
 * @classdesc お知らせカテゴリー変更
 */
export default class ChangeNewsCategory {
	/**
	 * @constructor
	 * @param {jQuery} $e - #news-category
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		$e.on('change', () => this.onChange());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ChangeNewsCategory
	 * @return undefined
	 */
	onChange() {
		console.log(`${this.constructor.name}.onChange`);
		const value = this._$e.val();
		let url = Common.getCurrentURL();
		if(value !== ''){
			url = `${url}?category=${value}`;
		}
		location.href = url;
	};
};
